import React, {useContext, useEffect, useState} from 'react'
import {Typography, Grid, Paper} from '@material-ui/core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {MyAccountContext} from '../../containers/Layout'
//import {enrolledConstantSchema} from '../../utils/constants.js'
import CardSelector from '../../components/CardSelector'
import GridContainer from '../../components/Grid/GridContainer'
import {prependZero, validateURL} from '../../../utils/utils'
import NoResultFound from '../../../components/NoResultFound/NoResultFound'
import {getMyAccountAPIData} from '../../services/myaccount'
import Loader from '../../../components/Loader'

const Enrolled = props => {
    const {
        routeObject,
        setrouteObject,
        clientObject,
        setClientObject,
        enrolledObject,
        setenrolledProgram,
        practiceObject,
        myAccountSchema,
    } = useContext(MyAccountContext)

    const [loading, setloading] = useState(false)
    let array = []

    useEffect(() => {
        getSubscribedPrograms()
    }, [])

    const cardHandler = obj => {
        switch (obj.actiontype.toLowerCase()) {
            case 'details':
            case 'knowmore':
                setrouteObject({
                    ...routeObject,
                    key: obj.key,
                    actiontype: obj.actiontype,
                    logo: obj.logo,
                    backrouter: 'enrolled',
                    // dashboard: obj.dashboardurl || null,
                    payment: obj.paymenthistory,
                    previousyearpayment: obj.previousyearpayment,
                    agreements: obj.agreements,
                    registryinfo: obj.registryinfo,
                    providertab: obj.cliniciandetails,
                    signup: obj.signup,
                    dashboard: obj.dashboard,
                })
                setClientObject({
                    ...clientObject,
                    clientprogramid: obj.clientprogramid || 0,
                    clientprogramname: obj.clientprogramname || '',
                    programid: obj.programid || 0,
                    programhost: obj.programhost || '',
                })
                break

            default:
                break
        }
    }

    const getSubscribedPrograms = () => {
        setloading(true)
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/subscribedprogram',
                {},
                {'client-entity-id': clientObject.cliententityid}
            )

            if (Object.entries(data).length > 0) {
                if (data.error && Object.keys(data.error).length > 0)
                    setenrolledProgram({
                        subscribedprogram: [],
                    })
                else setenrolledProgram(data)
            } else
                setenrolledProgram({
                    subscribedprogram: [],
                })

            setloading(false)
        }
        callApi()
    }

    if (enrolledObject.subscribedprogram && enrolledObject.subscribedprogram.length > 0) {
        enrolledObject.subscribedprogram.forEach((input, key) => {
            let subscribedSchema
            const arrayOfSubscribed = []
            enrolledObject.subscribedprogram.forEach(schema => {
                subscribedSchema = {}
                subscribedSchema = JSON.parse(
                    JSON.stringify(myAccountSchema.enrolledConstantSchema)
                )
                subscribedSchema.data = schema
                subscribedSchema.columnMedia[0]['imageUrl'] = schema.logo
                arrayOfSubscribed.push(subscribedSchema)
            })
            arrayOfSubscribed.map(e => (e['cardClickHandler'] = {cardHandler}))
            input.value = []
            input.value = arrayOfSubscribed
            array = arrayOfSubscribed
        })
    }

    const SubscribedProgramCards = () => {
        if (array.length === 0) {
            return (
                <Paper className="no-data_page white-wrapper-bg">
                    <Grid item xs={12} className="table-root__wrapper">
                        <NoResultFound
                            message={props.message || 'No subscribed program right now'}
                            imageName="Empty_container"
                        />
                    </Grid>
                </Paper>
            )
        } else {
            return (
                <GridContainer>
                    {array.map((schema, index) => {
                        return (
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <CardSelector
                                    key={'qualifiedCard_' + index}
                                    {...schema}
                                ></CardSelector>
                            </Grid>
                        )
                    })}
                </GridContainer>
            )
        }
    }

    const header = enrolledObject.subscribedprogram
        ? 'SUBSCRIBED PROGRAMS (' +
          (prependZero(enrolledObject.subscribedprogram.length) || 0) +
          ')'
        : 'SUBSCRIBED PROGRAMS (0)'

    return (
        <div className="ma-main-page__wrapper prgrm-hdr__wrpr">
            <Grid container spacing={3} className="program-dtls_header">
                <Grid item className="program-header__ttl">
                    <Typography
                        className="form-row--heading_h6"
                        variant="h6"
                        gutterBottom
                    >
                        <FontAwesomeIcon
                            icon={['fal', 'angle-left']}
                            onClick={() => props.setRouter('dashboard')}
                        ></FontAwesomeIcon>
                        &nbsp;
                        {header}
                    </Typography>
                </Grid>
                <Grid item xs className="program-header__practice-name__wrapper">
                    <Grid xs className="program-header__practice-name">
                        <div className="practice__name">
                            {' '}
                            {practiceObject.practicename}
                            <span className="practice__id">
                                ({practiceObject.practiceId})
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {loading && <Loader type="page" />}
            {!loading && <SubscribedProgramCards />}
        </div>
    )
}

export default Enrolled
